/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/topappbar/top-app-bar.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { BehaviorSubject } from 'rxjs';
/**
 * @record
 */
export function Style() { }
if (false) {
    /** @type {?} */
    Style.prototype.mode;
    /** @type {?} */
    Style.prototype.color;
    /** @type {?|undefined} */
    Style.prototype.title;
    /** @type {?|undefined} */
    Style.prototype.mergeCallback;
}
/** @type {?} */
export const defaultStyle = {
    mode: "default",
    color: "primary",
};
export class TopAppBarService {
    constructor() {
        this.style$ = new BehaviorSubject(defaultStyle);
    }
    /**
     * @return {?}
     */
    search() {
        this.style$.next({
            mode: "search",
            color: "accent",
        });
    }
    /**
     * @return {?}
     */
    default() { this.style$.next(defaultStyle); }
    /**
     * @param {?} title
     * @param {?} mergeCallback
     * @return {?}
     */
    bulk(title, mergeCallback) {
        this.style$.next({
            mode: "bulk",
            color: "accent",
            title,
            mergeCallback,
        });
    }
}
if (false) {
    /** @type {?} */
    TopAppBarService.prototype.style$;
}
//# sourceMappingURL=data:application/json;base64,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